import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../API/apiService";
import { API_ENDPOINTS } from "../../../API/endpoints";
import { localStorageUtil } from "../../../utils/CommonFunctions";
import { useBridgeStore } from "../../../store/apis/useBridgeStore";

const ConfirmationModal = ({ isOpen, onClose, channelId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const triggerDraftRefresh =  useBridgeStore(store => store.triggerDraftRefresh)
  const UserData = JSON.parse(localStorage.getItem("userData"));
  let rout = UserData?.domain || "elsnertech";

  const leaveChannelApi = async () => {
    setLoading(true);
    try {
      const response = await ApiService.post(
        `${API_ENDPOINTS.leaveChannel}/${channelId}`
      );

      if (response?.data) {
        const defaultChannelId = localStorage.getItem("defaultChannelId");
        const userData = JSON.parse(localStorage.getItem("userData")) || {};
        userData.lastActiveChat = null; // clear last active to avoid redirect to removed channel
        localStorage.setItem("userData", JSON.stringify(userData));
        localStorage.setItem("current_id", "");
        navigate(`/${rout}/welcome`);
        if (defaultChannelId) {
          localStorageUtil.removeItem(`draft-${channelId}`);
          triggerDraftRefresh(Date.now());
        }
        onSuccess?.();
        onClose();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Confirm Leave Channel"
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} className="text-btn">
          Cancel
        </Button>,
        <Button
          key="create"
          type="primary"
          onClick={leaveChannelApi}
          loading={loading}
          className="danger-btn ant-btn"
        >
          Leave
        </Button>
      ]}
      className="ec-modal rename-channel-modal"
      width={600}
      style={{ top: 20 }}
    >
      <div className="delete-msg-confirmation">
        <span>Are you sure you want to Leave this Channel?</span>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
